import * as z from "zod/v4";

export const generateLicensePlate = {
  name: "generateLicensePlate" as const,
  input: z.object({
    returnItemId: z.string().min(1),
    sku: z.string().optional(),
    productTitle: z.string().optional(),
    variantTitle: z.string().optional(),
  }),
  output: z.object({ pdfUrl: z.string() }),
};
